import en from './en'
import es from './es'

export const messages = { en, es }
